import { render, staticRenderFns } from "./MarketingSection.vue?vue&type=template&id=60cac2a5&scoped=true&"
import script from "./MarketingSection.vue?vue&type=script&lang=js&"
export * from "./MarketingSection.vue?vue&type=script&lang=js&"
import style0 from "./MarketingSection.vue?vue&type=style&index=0&id=60cac2a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cac2a5",
  null
  
)

export default component.exports